import moment from "moment";
import { SetStateFunctionType } from "../../types";

export type DrugType = {
  drugId: number;
  drugCode: string;
  drugPackageName: string;
  drugGenericName: string;
  drugPrice: number;
  drugStrength: string;
  drugDosageForm: string;
  drugRoot: string;
  drugStatus: number;
  isTablet: number;
  drugUnit: string;
  drugCreatedById: number;
  drugCreatedByDate: string;
  drugAmount:number;
  clinicId: number;
  isFavorite?: number;
};

export type DrugunitType = {
  id: number;
  name: string;
  description: string;
  code: string;
  clinicId: number;
};

export type DrugFrequencyType = {
  freqId: number;
  freqCode: string;
  freqName: string;
  freqClinicId: number;
  freqStatus: number;
  freqAmount: number;
};

export type DosageTimingType = {
  doseTiming: string;
  id: number;
};

export type RouteOfAdminType = {
  routeId: number;
  roaCode: string;
  routeClinicId: number;
  routeName: string;
};

export type PrescriptionType = {
  eRxNo: string;
  encounterId: string;
  prescriptionId: number;
  drug: DrugType | null;
  dosage: string;
  prescriptionUnit: DrugunitType | null;
  frequencyResponse: DrugFrequencyType | null;
  dosageTiming: DosageTimingType | null;
  prescriptionDuration: string;
  routeOfAdmin: RouteOfAdminType | null;
  refill: string;
  startDate: string | Date;
  notes: string;
  prescriptionQuantity: string;
  prescriptionRemarks: string;
  status: boolean;
  doneBy: string;
  createdByDate: Date | string;
};

export type PrescriptionContextType = {
  list: PrescriptionType[];
  setList: SetStateFunctionType<PrescriptionType[]>;
  edit: PrescriptionType | null;
  setEdit: SetStateFunctionType<PrescriptionType | null>;
};

export const defaultValues: PrescriptionType = {
  encounterId: "0",
  doneBy: "",
  dosage: "",
  status: true,
  prescriptionUnit: null,
  dosageTiming: null,
  drug: null,
  prescriptionDuration: "",
  frequencyResponse: null,
  prescriptionRemarks: "",
  notes: "",
  prescriptionId: 0,
  prescriptionQuantity: "",
  refill: "0",
  routeOfAdmin: null,
  startDate: "",
  eRxNo: "",
  createdByDate: "",
};

export type PrescriptionPayloadType = {
  prescriptionId: number | null;
  prescriptionDosage: string;
  prescriptionDuration: string;
  freqId: number;
  prescriptionFrequency: string;
  prescriptionQuantity: number;
  prescriptionRefill: number;
  prescriptionRemarks: string;
  prescriptionRoute: string;
  prescriptionStatus: number;
  routeInsId: number;
  drugId: number;
  encounterId: number;
  eRxNo: string;
  unit: number;
  prescriptionRoot: number;
  startDate: string;
  dosageTimingCode: string;
  dosageTiming: string;
  notes: string;
  dosageUnit: number;
  prescriptionClinicId: number;
  prescriptionCreatedById: number;
  prescriptionCreatedByDate: string | Date;
  userType: number;
};

export const preparePrescriptionPayload = (
  data: PrescriptionType
): Omit<
  PrescriptionPayloadType,
  "prescriptionClinicId" | "prescriptionCreatedById" | "userType"
> => {
  return {
    prescriptionId: data.prescriptionId || null,
    prescriptionDosage: data.dosage,
    prescriptionDuration: data.prescriptionDuration,
    freqId: data.frequencyResponse?.freqId as number,
    prescriptionFrequency: data.frequencyResponse?.freqName as string,
    prescriptionQuantity: parseInt(data.prescriptionQuantity),
    prescriptionRefill: parseInt(data.refill),
    prescriptionRemarks: data.prescriptionRemarks,
    prescriptionRoute: data.routeOfAdmin?.routeName as string,
    prescriptionStatus: 1,
    routeInsId: data.routeOfAdmin?.routeId as number,
    drugId: data.drug?.drugId as number,
    encounterId: parseInt(data.encounterId),
    eRxNo: data.eRxNo,
    unit: data.prescriptionUnit?.id as number,
    prescriptionRoot: data.routeOfAdmin?.routeId as number,
    startDate: moment(data.startDate as string).format("YYYY-MM-DD"),
    dosageTimingCode: data.dosageTiming?.doseTiming as string,
    dosageTiming: data.dosageTiming?.doseTiming as string,
    notes: data.notes,
    dosageUnit: data.prescriptionUnit?.id as number,
    prescriptionCreatedByDate: data.createdByDate,
  };
};
